import { call, takeLatest, take, race, takeEvery } from "redux-saga/effects";

import * as actions from "services/redux/actions";

import { liveRefreshFor } from "services/redux/sagas/common";

import conxtdOut from "apis/conxtdOut";

import * as links from "./links";

export function* watchLiveRefresh() {
  // Sites - when failed to close report finishes loading, start a background task to load sites
  yield takeLatest(
    [
      // Pre-loading
      "LOAD_FAILED_TO_CLOSE_REPORT_SUCCESS"
    ],
    links.toSitesBackgroundLoader
  );

  // Event meta data - when failed to close reports finish loading, start a background task to load event meta
  yield takeLatest(
    [
      // Pre-loading
      "LOAD_FAILED_TO_CLOSE_REPORT_SUCCESS"
    ],
    links.toEventMetaBackgroundLoader
  );

  yield takeEvery("LOAD_FAILED_TO_CLOSE_REPORT_START", function*(action) {
    yield race({
      task: call(loadStart, action),
      cancel: take([
        "LOAD_FAILED_TO_CLOSE_REPORT_CANCEL",
        "LOAD_FAILED_TO_CLOSE_REPORT_FAILED",
        "CANCEL_ALL_LIVE_REFRESH",
        "CANCEL_ALL"
      ])
    });
  });
}

export function* loadStart(action) {
  const { interval, enterprise_id, group_id, refresh } = action;
  const reportType = "index";

  const params = {
    startAction: actions.loadFailedToCloseReportStart,
    startActionParams: action,
    successAction: actions.loadFailedToCloseReportSuccess,
    failedAction: actions.loadFailedToCloseReportFailed,
    apiCall: call(
      conxtdOut.get,
      `/analyticx/reports/daily/live/failedtoclose/?enterprise_id=${enterprise_id}${group_id ? "&group_id=" + group_id : ""}`
    ),
    interval,
    key: reportType,
    successActionParams: {
      enterprise_id,
    },
    refresh
  };

  yield liveRefreshFor(params);
}